<template>
  <Card class="section-card">
    <p class="title" v-if="title">{{ title }}</p>
    <slot />
  </Card>
</template>

<script>
import Card from '@/components/atoms/Card'

export default {
  name: 'SectionCard',
  props: {
    title: {},
  },
  components: {
    Card,
  },
}
</script>

<style scoped lang="scss">
.section-card {
  margin-bottom: 10px;
  padding: 20px 20px 30px;
}

.title {
  font-weight: bold;
  padding: 10px 0 20px;
  text-align: center;
}
</style>
